import { post, get } from '@/utils/request';

export const list = (data) => get('/finance/incidental/page', data)

export const audit = (data) => post(`/finance/incidental/audit`, data)

export const tgApi = (data) => post(`/finance/incidental/tg`, data)

export const rejectApi = (data) => post(`/finance/incidental/reject`, data)

export const exportApi = (data) => post(`/finance/incidental/export`, data)

export default { list, audit, tgApi, rejectApi, exportApi }
